import { createAction, props } from '@ngrx/store';
import { IntegrationEventLogDetails } from '../../models/integration-event-log-details';
import { IntegrationRecordLogsDetails } from '../../models/integration-record-log-details.model';

export enum IntegrationEventLogDetailsActionsEnum {
    LoadEventLogDetails = '[INTEGRATION EVENT LOG API] Load event log details',
    LoadEventLogDetailsSuccess = '[INTEGRATION EVENT LOG API] Load event log details success',
    LoadEventLogDetailsCompletion = '[INTEGRATION EVENT LOG API] Load event log details completion',
    LoadRecordLogs = '[INTEGRATION EVENT LOG API] Load record logs',
    LoadRecordLogsSuccess = '[INTEGRATION EVENT LOG API] Load record logs success',
    LoadRecordLogsCompletion = '[INTEGRATION EVENT LOG API] Load record logs completion'
}

export const loadEventLogDetails = createAction(
    IntegrationEventLogDetailsActionsEnum.LoadEventLogDetails,
    props<{ eventLogId: string }>()
);

export const loadEventLogDetailsSuccess = createAction(
    IntegrationEventLogDetailsActionsEnum.LoadEventLogDetailsSuccess,
    props<{ eventLogDetails: IntegrationEventLogDetails }>()
);

export const loadEventLogDetailsCompletion = createAction(
    IntegrationEventLogDetailsActionsEnum.LoadEventLogDetailsCompletion
);

export const loadRecordLogs = createAction(
    IntegrationEventLogDetailsActionsEnum.LoadRecordLogs,
    props<{ eventLogId: string; recordKey: string }>()
);

export const loadRecordLogsSuccess = createAction(
    IntegrationEventLogDetailsActionsEnum.LoadRecordLogsSuccess,
    props<{ recordLogs: IntegrationRecordLogsDetails }>()
);

export const loadRecordLogsCompletion = createAction(IntegrationEventLogDetailsActionsEnum.LoadRecordLogsCompletion);

export const IntegrationEventLogDetailsActions = {
    loadEventLogDetails,
    loadEventLogDetailsSuccess,
    loadEventLogDetailsCompletion,
    loadRecordLogs,
    loadRecordLogsSuccess,
    loadRecordLogsCompletion
};
